<template>
	<MarkdownPage>
		<MarkdownHeader
			:title="$t('privacy.title')"
		/>
		<MarkdownContent
			:html="$t('privacy.copy')"
		/>
	</MarkdownPage>
</template>

<script setup>
import {
	BASE_URL, COMPANY_NAME
} from '@/constants/index.js'
import { useI18n } from 'vue-i18n'

const { t } = useI18n({
	useScope: 'global'
})

useHead({
	title: t('privacy.meta-title'),
	meta: [
		{ name: 'url',
			content: `${BASE_URL}/privacy` },
		{ name: 'description',
			content: t('privacy.meta-description', { COMPANY_NAME }) }
	]
})
</script>
